module.exports = "/_next/static/images/video_id_7171113427740527878-a70f37e4116fe76098168852099d6ee1.jpg";